const messageKeys = [
  'ABILITY_CHANGE',
  'AI_PRIORITIES_CHANGE',
  'ATTRIBUTE_CHANGE',
  'GOT_HERO_BUILDS',
  'HERO_BUILD_DELETED',
  'HERO_UNLOCKED',
  'ITEM_EQUIPPED',
  'ITEM_UNEQUIPPED',
  'NEW_HERO_BUILD_CREATED',
  'RESET_ABILITIES_REQUESTED',
];

const messages: Record<HeroBuildStoreMessage, HeroBuildStoreMessage> = Object.fromEntries(
  messageKeys.map((k) => [k, k])
) as Record<HeroBuildStoreMessage, HeroBuildStoreMessage>;
export default messages;

export type HeroBuildStoreMessage = (typeof messageKeys)[number];
